import React from 'react';
import { FaClipboardList, FaPlusCircle } from 'react-icons/fa'; // Importa o ícone para estoque
import styles from './MobileNav.module.css';

const MobileNav = ({ activeView, setActiveView }) => {
  // Este componente só é visível em telas mobile, controlado via CSS.
  return (
    <nav className={styles.mobileNav}>
      <button
        className={`${styles.navButton} ${activeView === 'pedidos' ? styles.active : ''}`}
        onClick={() => setActiveView('pedidos')}
      >
        <FaClipboardList className={styles.navIcon} />
        Pedidos
      </button>
      <button
        className={`${styles.navButton} ${activeView === 'vender' ? styles.active : ''}`}
        onClick={() => setActiveView('vender')}
      >
        <FaPlusCircle className={styles.navIcon} />
        Vender
      </button>
    </nav>
  );
};

export default MobileNav;